export default {

    namespaced: true,

    state: {
        operation: null,
        form: {
            model: {
                id: null,
                corporation: null,
                parentOrgId: null,
                code: null,
                name: null,
                leaderId: null,
                corporateId: null,
                syncFromShr: false,

                orgId: null,
            },
        },
    },

    getters: {

    },

    mutations: {
        setOperation(state, operation) {
            state.operation = operation;
        },
        setFormModel(state, formModel) {
            state.form.model = formModel;
        },
    },

    actions: {

    },

}